import { useState } from "react"
import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import {
    clearObtenerINECotizacionAction,
    obtenerINECotizacionAction,
} from "../../../ducks/cotizacioensDuck"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"
const useDocumentoIne = ({ idCotizacion }) => {
    const [document, setDocument] = useState([])
    const dispatch = useDispatch()
    useEffect(() => {
        dispatch(obtenerINECotizacionAction({ idCotizacion })).then((response) => {
            if (response) {
                setDocument(response)
            }
        })
        return () => {
            dispatch(clearObtenerINECotizacionAction())
            setDocument([])
        }
    }, [dispatch, idCotizacion])
    return { document }
}
const DocumentIne = ({ idCotizacion }) => {
    // const { documentINE } = useSelector((store) => store.cotizaciones);
    const [open, setOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const { document } = useDocumentoIne({ idCotizacion })
    const handleImageClick = (img) => {
        setSelectedImage(img)
        setOpen(true)
    }
    const handleClose = () => {
        setOpen(false)
        setSelectedImage(null)
    }
    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "10px",
                }}
            >
                {document.map((img) => (
                    <div
                        key={img.IdCotizacionDocumento}
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "30px",
                        }}
                    >
                        <img
                            src={`data:image/${img.Extension};base64,${img.Imagen}`}
                            alt={`imagen-${img.IdCotizacionDocumento}`}
                            style={{
                                width: "150px",
                                height: "auto",
                                borderRadius: "5px",
                                cursor: "pointer",
                                maxWidth: "100px",
                            }}
                            onClick={() => handleImageClick(img)}
                        />
                        <p>{img.Frontal ? "Frontal" : "Reverso"}</p>
                    </div>
                ))}
            </div>
            <Dialog open={open} onClose={handleClose} maxWidth="md">
                <DialogContent style={{ display: "flex", justifyContent: "center" }}>
                    {selectedImage && (
                        <img
                            src={`data:image/${selectedImage.Extension};base64,${selectedImage.Imagen}`}
                            alt={`imagen-grande-${selectedImage.IdCotizacionDocumento}`}
                            style={{ width: "100%", maxWidth: "600px", height: "auto" }}
                        />
                    )}
                </DialogContent>
            </Dialog>
        </>
    );
};

export default DocumentIne;